import {Grid, Stack, Tooltip, Typography} from "@mui/material";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import axiansLogo from "../../../assets/images/axians.webp";
import finkiLogo from "../../../assets/images/finki.png";
import fitrLogo from "../../../assets/images/fitr.png";

export const Partners = () => {

  const partners = [
    // {
    //   image: "https://firebasestorage.googleapis.com/v0/b/blockflow-dev-60600.appspot.com/o/projects%2F5adf3d25-8fae-4af8-b0b7-ed0a23a69fb7-zan-mitrev.jpg?alt=media&token=b249ba42-cfe3-4112-93ef-1acd78647139",
    //   name: "Zan Mitrev Clinic",
    // },
    // {
    //   image: "https://firebasestorage.googleapis.com/v0/b/blockflow-dev-60600.appspot.com/o/projects%2F6a889a1d-de3d-4961-ba4f-b7045a08d583-a1mk-logo.png?alt=media&token=2b289df4-9a61-4bf5-aa20-6755cd032faf",
    //   name: "A1 Macedonia",
    // },
    {
      image: finkiLogo,
      name: "FINKI",
      // url: "https://finki.ukim.mk/",
    },
    {
      image: fitrLogo,
      name: "FITR",
      // url: "",
    },
    {
      image: axiansLogo,
      name: "axians",
      // url: "",
    },
    // {
    //   image: "https://firebasestorage.googleapis.com/v0/b/blockflow-dev-60600.appspot.com/o/projects%2F6a889a1d-de3d-4961-ba4f-b7045a08d583-a1mk-logo.png?alt=media&token=2b289df4-9a61-4bf5-aa20-6755cd032faf",
    //   name: "A1 Croatia",
    // },
  ]


  return (
    <Grid container spacing={{xs: 2, md: 6}} alignItems={"center"} justifyContent={"center"} sx={{px: {xs: 2, md: 6}, pt: {xs: 4, md: 10}, pb: {xs: 5, md: 10, lg: 20} }}>
      <Grid item xs={12}>
        <Typography align={"center"} sx={{width: "100%"}} fontSize={{xs: "1.2em", md: "1.6em", lg: "1.8em"}} fontWeight={500}>
          Our Partners
        </Typography>
      </Grid>
      <Grid item xs={12} maxWidth={"lg"}>
        <Swiper
          slidesPerView={'auto'}
          spaceBetween={30}
          pagination={{ clickable: true }}
          centeredSlides={true}
          style={{ padding: "40px", margin: 0 }}
          initialSlide={Math.floor(partners?.length / 2)}
          modules={[Navigation]}
          className="mySwiper"
        >
          {partners?.map(partner => {
            return (
              <SwiperSlide key={partner?.name}  style={{width: "200px"}}>
                <Tooltip title={partner?.name}>
                  <Stack direction={"column"} gap={1} alignItems={"center"} sx={{cursor: "pointer", "&:hover": {transform: "scale(1.1)"} }}>
                    <img src={partner?.image} alt={partner?.name} width={130} height={130} style={{objectFit: "contain"}} />
                    <Typography fontWeight={600} align={"center"}>{partner?.name}</Typography>
                  </Stack>
                </Tooltip>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </Grid>
    </Grid>
  )
}